import * as angular from 'angular';
import { IAugmentedJQuery } from 'angular';
import { MobileOS } from 'types/enums';

import { FlagshipService } from 'services/flagship';
import { getMobileOS } from 'utilities/devices';

import './styling.scss';
import * as template from './template.html';

const module = angular.module('app-download-card', []);

export const APPLE_APP_STORE_URL = 'https://apps.apple.com/us/app/hippo/id1565212096';
export const GOOGLE_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.hippo.insurance';


interface AppDownloadCardController extends angular.IStrictController {
    title: string;
    description: string;
    appleAppStoreUrl: string;
    googlePlayStoreUrl: string;
    showAppleAppStoreLink: boolean;
    showGoolePlayStoreLink: boolean;
    isIOS: boolean;
    isAndroid: boolean;
}

module.component('appDownloadCard', {
    template: template,
    controller: function(
        this: AppDownloadCardController,
        $element: IAugmentedJQuery,
        $scope: angular.IScope,
        flagshipService: FlagshipService
    ) {
        const checkFeatureFlag = () => {
            if (flagshipService.getFlag('mobileAppDownloadRightRail') === true) {
                $element.removeClass('ng-hide');
            }
        };

        this.$onInit = () => {
            $element.addClass('ng-hide');
            if (flagshipService.getFeatureFlagStatus() === 'FeatureFlagStatus:Ready') {
                checkFeatureFlag();
            } else {
                $scope.$on('FeatureFlagStatus:Ready', () => {
                    checkFeatureFlag();
                });
            }

            const deviceOS = getMobileOS();
            this.title = deviceOS === MobileOS.Other ? 'Check your home health' : 'Get the app';
            this.description = 'Get the new Hippo app and improve your home health with personalized recommendations from Hippo Home Care.';
            this.appleAppStoreUrl = APPLE_APP_STORE_URL;
            this.googlePlayStoreUrl = GOOGLE_PLAY_STORE_URL;
            this.showAppleAppStoreLink = deviceOS !== MobileOS.Android;
            this.showGoolePlayStoreLink = deviceOS !== MobileOS.iOS;
        };
    }
});

export { module };
